<script setup>
import UserTimelineHeading from "~/components/timeline/UserTimelineHeading.vue";
import UserTimelineLayoutItem from "~/components/timeline/UserTimelineLayoutItem.vue";
import {ref} from "vue";

defineProps({
  item: {
    type: Object,
    required: true
  }
})

const current = ref(0) // Optional: for tracking index
</script>

<template>
  <div class="carousel-item-layout">
    <user-timeline-heading
        :title="item.layoutData.title"
        :subtitle="item.layoutData.subTitle"
    />

        <div v-for="listItem in item.layoutData.items.slice(0,3)"
             :key="listItem.id" class="timeline-item">
          <user-timeline-layout-item :item="listItem"/>
        </div>

  </div>
</template>

<style scoped lang="scss">
.timeline-item:not(:last-child) {
  margin-bottom: 10px;
}
</style>
